var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowseExpertVerifiedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0586C0 4.98349 4.92487 0.0586243 11 0.0586243H64V53.0586C64 59.1338 59.0751 64.0586 53 64.0586H0V11.0586Z",
    fill: "#063065"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3939 25.7986L33.1818 23.5649C32.4271 23.2414 31.5729 23.2414 30.8182 23.5649L25.6061 25.7986C25.2384 25.9562 25 26.3178 25 26.7178V31.9707C25 33.9084 25.9358 35.7268 27.5126 36.8531L30.8375 39.2281C31.5329 39.7248 32.4671 39.7248 33.1625 39.2281L36.4874 36.8531C38.0642 35.7268 39 33.9084 39 31.9707V26.7178C39 26.3178 38.7616 25.9562 38.3939 25.7986ZM35.7809 29.6833C36.1259 29.2521 36.056 28.6228 35.6247 28.2778C35.1934 27.9327 34.5641 28.0027 34.2191 28.4339L30.9171 32.5615L29.7071 31.3515C29.3166 30.961 28.6834 30.961 28.2929 31.3515C27.9024 31.742 27.9024 32.3752 28.2929 32.7657L29.8979 34.3707C30.53 35.0029 31.5714 34.9452 32.1298 34.2471L35.7809 29.6833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseExpertVerifiedIcon);
export default __webpack_public_path__ + "static/media/BrowseExpertVerifiedIcon.31713588539e2cdcc553d62c72f58774.svg";
export { ForwardRef as ReactComponent };